import { useEffect } from 'react';
import { useLocation } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from "react-router-dom";
import * as actions from '../actions/dashboardactions';
import ChartContainer from '../components/ChartContainer/ChartContainer';
import MultiSelectDropdown from '../components/DropDown/MultiSelectDropdown'
import * as appUtilityFunction from '../../../infrastructure/apputilityfunctions';
import { checkAccess } from '../../../actions/securityactions';


import * as securityActions from '../../../actions/securityactions';
import LeftSideMenu from '../../../components/newdashboardcomponent/LeftSideMenu';
import TopBar from '../../../components/newdashboardcomponent/TopBar';
import Footer from '../../../components/Footer';

export default function Dashboard1() {
    const location = useLocation();
    const { pathname } = location;
    const pathnameWithoutSymbol = pathname.substring(1);

    const state = useSelector(state => state.dashboardReducer);
    const dispatch = useDispatch();
    const userDashboard = state.userDashboard;
    const navigate = useNavigate();
    let pageMenuId = appUtilityFunction.getUrlParameter('pageId');
    console.log('dashboardReducer',state)
    let agentDropDownList = state.agentsList.map((agent) => {
        let obj = {
            value: agent.agentId,
            label: agent.agentName
        }
        return obj
    })
    useEffect(() => {
        dispatch(securityActions.checkAccess({ pageMenuId })).then(resp => {
            if (!resp) {
                redirectIfRequired();
            }
        });
        async function getUserDashboard() {
            await dispatch(actions.getUserDashboard());
        }
        async function getUserBranch(){
            await dispatch(actions.getUserBranch());
        }
        async function getMasters(){
            await dispatch(actions.CheckIfAgentOrBroker())
            await dispatch(actions.getAgentsList());
            await dispatch(actions.getSalesChannel());
        }
        getMasters();
        getUserDashboard();
        getUserBranch();
    }, []);
   
    function redirectIfRequired() {
        if (pageMenuId == null || pageMenuId == '') {
            navigate('/login');
        } else {
            dispatch(securityActions.redirectToPage(pageMenuId));
        }
    }
    if (userDashboard.userdashboards == null) {
        return <div></div>
    }

    const handleDashboardAnalyticsParam = (e) => {
        let { name, value } = e.target;
        dispatch(actions.updateDashboardAnalyticsParam({ name, value }));
    }
    const resetParams = () => {
        dispatch(actions.resetParams())
    }

    
    function renderAnalyticsParamsComponent() {

        let fromDate = <input className='form-control'  
            type="date" id="fromDate" required=""
            name='fromDate'
            onChange={(e) => handleDashboardAnalyticsParam(e)}
            value={state.fromDate}
        />
        let toDate = <input className='form-control'  
            type="date" id="toDate" required=""
            name='toDate'
            onChange={(e) => handleDashboardAnalyticsParam(e)}
            value={state.toDate}
        />
        let system =
            <select className='form-select'  
                data-toggle="system" id="system" name="system"
                onChange={(e) => handleDashboardAnalyticsParam(e)}
                value={state.system}
            >
                <option value="">--All Systems--</option>
                {state.systemMasters.map((sys) => (
                    <option value={sys.systemId} key={sys.systemId}>
                        {sys.title}
                    </option>
                ))}
            </select>
        let branch =
        <select className='form-select'  
            data-toggle="branch" id="branch" name="branch"
            onChange={(e) => handleDashboardAnalyticsParam(e)}
            value={state.branch}
        >
            <option value="">--All Branch--</option>
            {state.userBranch && state.userBranch.map((brc) => (
                <option value={brc.bR_CODE} key={brc.bR_CODE}>
                    {brc.bR_NAME}
                </option>
            ))}
        </select>
        let agents =
        <select className='form-select'
            data-toggle="branch" id="agentId" name="agentId"
            onChange={(e) => handleDashboardAnalyticsParam(e)}
            value={state.agentId}
        >
            <option value="">--All Agents--</option>
            {state.agentsList && state.agentsList.length>0 && state.agentsList.map((brc) => (
                <option value={brc.agentId} key={brc.agentId}>
                    {brc.agentName}
                </option>
            ))}
        </select>
        let SalesChannel =
        <select className='form-select'  
            data-toggle="salesChanelId" id="salesChanelId" name="salesChanelId"
            onChange={(e) => handleDashboardAnalyticsParam(e)}
            value={state.salesChanelId}
        >
            <option value="">--All Business Channels--</option>
            {state.salesChannelList && state.salesChannelList.length >0 && state.salesChannelList.map((brc) => (
                <option value={brc.domainValue} key={brc.domainValue}>
                    {brc.domainValueName}
                </option>
            ))}
        </select>

        return (
            <div class="page-title-box">
                <div class="page-title-right">
                    <form class="d-flex">
                        <div class="input-group ms-2">
                            {system}
                        </div>
                        <div class="input-group ms-2">
                            {!state.isAgentorBroker && SalesChannel}

                        </div>
                        <div class="input-group ms-2">
                            {!state.isAgentorBroker && <MultiSelectDropdown inputOptions={agentDropDownList} />}
                        </div>
                        <div class="input-group ms-2">
                            {fromDate}
                            {/*<span class="input-group-text bg-primary border-primary text-white">
                                <i class="mdi mdi-calendar-range font-13"></i>
                        </span>*/}
                        </div>
                        <div class="input-group ms-2">
                            {toDate}

                        </div>
                        <div class="input-group ms-2">
                            {branch}
                        </div>
                        <button onClick={() => resetParams()} class="btn btn-primary ms-2">
                            <i class="mdi mdi-autorenew"></i>
                        </button>
                    </form>
                </div>

                <hr />
            </div>

        )
    }
    function renderChartContainer() {
        if (!userDashboard?.userdashboards) {
            return null;
        }

        let userdashboards = userDashboard.userdashboards;
        //applay filter here based on the system selection
        if (state.system) {
            userdashboards = userDashboard.userdashboards.filter(p => p.systemId == state.system);
        }
        const distinctSystemIds = [...new Set(userdashboards.map(dashboard => dashboard.systemId))];
        // const distinctSystem = distinctSystemIds.map((systemId) => {
        //     const dashboard = userdashboards.filter((d) => d.systemId === systemId);
        //     return dashboard;
        // });
        const distinctGroupIds = [...new Set(userdashboards.map(dashboard => dashboard.dashboardGroupId))];
        const distinctCatIds = Array.from(
            new Map(userdashboards.map(dashboard => [dashboard.dashboardCatId, {
                CategoryId: dashboard.dashboardCatId,
                CategoryDesc: dashboard.dashboardCatDesc
            }])).values()
        );
        const distinctCategoryandGroupandSystem = distinctSystemIds.map((systemId) => {
            var dashboard = distinctGroupIds.map((groupId) => {
                var category = distinctCatIds.map((catId) => {
                    const catResult = userdashboards.filter((d) => d.systemId === systemId && d.dashboardGroupId === groupId && d.dashboardCatId === catId.CategoryId);
                    if (catResult.length === 0){
                        return null;
                    } 
                    const obj = {
                        System: systemId,
                        Group: groupId,
                        Category: catId.CategoryId,    
                        CategoryDesc: catId.CategoryDesc,              
                        result: catResult
                    }                    
                    return obj;
                }).filter(Boolean)

                return category;
            })
            return dashboard
        });
        console.log('SSO userdashboards', userdashboards)
        console.log('SSO distinctGroupIds', distinctGroupIds)
        console.log('SSO distinctCatIds', distinctCatIds)
        console.log('SSO distinctCategoryandGroupandSystem', distinctCategoryandGroupandSystem)
       
        return (
            <>
                <div class="row">
                    {distinctCategoryandGroupandSystem.map((arr, index) => (
                        <div class='row' key={index}>
                            {state.system && <h4 style={{ fontSize: "25px" }} >{appUtilityFunction.getSystemName(Number(state.system))}</h4>}
                            <hr />
                            {arr.map(group => (
                                <>
                                    <div class='row' key={index}>
                                        {
                                            group.map((category, catIndex) => (
                                                <>

                                                    <div class='row' key={catIndex}>
                                                        <h4 style={{ fontSize: "20px", fontStyle: "italic", textDecoration: "underline", color: "#084298" }}>{category.CategoryDesc} </h4>
                                                        <hr />
                                                        {
                                                            category.result.map(dashboard => (
                                                                <>
                                                                    <ChartContainer key={dashboard.dashboardId} dashboardId={dashboard.dashboardId} />

                                                                </>
                                                            ))
                                                        }
                                                    </div>
                                                </>
                                            ))
                                        }

                                    </div>


                                </>
                            ))}
                        </div>

                    ))}
                </div>
            </>

        )
    }
    return (
        /*-- Begin page */
        <div class="wrapper">
            <LeftSideMenu />

            <div class="content-page">
                <div class="content">
                    <TopBar />
                    <div class="container-fluid">

                        {/*!-- start page title -->*/}
                        <div class="row">
                            <div class="col-12">
                                <div class="page-title-box">
                                    <div class="page-title-left">

                                        {location.pathname == '/' ?
                                            <h4 className="page-title">Dashboard</h4> :
                                            <ol class="breadcrumb m-0">
                                                <li class="breadcrumb-item"><a href="javascript: void(0);">Home</a></li>
                                                <li class="breadcrumb-item"><a href="javascript: void(0);">{pathnameWithoutSymbol}</a></li>
                                            </ol>
                                        }

                                    </div>
                                </div>
                            </div>
                        </div>
                        {/*!-- end page title -->*/}


                        <div class="row">
                            <div class="col-12">{renderAnalyticsParamsComponent()}</div> 
                        </div>
                        <div class="row">
                          <div class="col-12">{renderChartContainer()}</div> 
                        </div>


                    </div>
                </div>
                <Footer />
            </div>



        </div>


    )
}
